__turbopack_context__.v({
  "centerGlow": "LoadingSpinner-module__1XABeq__centerGlow",
  "dot": "LoadingSpinner-module__1XABeq__dot",
  "label": "LoadingSpinner-module__1XABeq__label",
  "orbitGroup": "LoadingSpinner-module__1XABeq__orbitGroup",
  "orbitGroupDelayed": "LoadingSpinner-module__1XABeq__orbitGroupDelayed",
  "orbitGroupSlow": "LoadingSpinner-module__1XABeq__orbitGroupSlow",
  "orbitRing": "LoadingSpinner-module__1XABeq__orbitRing",
  "pulse": "LoadingSpinner-module__1XABeq__pulse",
  "root": "LoadingSpinner-module__1XABeq__root",
  "spin": "LoadingSpinner-module__1XABeq__spin",
  "spinner": "LoadingSpinner-module__1XABeq__spinner",
  "srOnly": "LoadingSpinner-module__1XABeq__srOnly",
});
